import { createRouter, createWebHistory } from 'vue-router'
import Register from '../views/Register.vue'

const routes = [
  {
    path: '',
    name: 'register',
    component: Register,
    meta: {
      title: 'SYNCROSUPPLY CENTRAL'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Default Tile'
  next()
})

export default router
